import React, { useState } from 'react'
import { useNotification } from '../../services/customHooks/useNotification'
import AdminSideMenuv2 from '../../features/adminSideMenu'
// import AdminSideMenu from '../2compounds/AdminSideMenu'

export default function DashboardNavigation({
  isNavigationOpen,
  setIsNavigationOpen
}) {
  const [minimizeMenu, setMinimizeMenu] = useState(false)
  useNotification()

  return (
    <>
      {/* <AdminSideMenu
        isNavigationOpen={isNavigationOpen}
        setIsNavigationOpen={setIsNavigationOpen}
      /> */}
      <AdminSideMenuv2
        minimizeMenu={minimizeMenu}
        setMinimizeMenu={setMinimizeMenu}
      />
    </>
  )
}
